import { RootState } from "../../redux/reducers";
import { store } from "../../redux/store";
import httpService from "../httpService";
import { CheckOnboardingDto, StripeConnectLoginLink } from "../../models/marketplace.model";

export async function createMerchantAccount(): Promise<CheckOnboardingDto> {
  const { selectedDashboard } = (store.getState() as RootState).application;
  if (!selectedDashboard) {
    throw new Error('NO_DASHBOARD_SELECTED');
  }
  return httpService
    .post<CheckOnboardingDto>(`/marketplace/account/${selectedDashboard}`)
    .then((res) => res.data)
    .catch((err) => {
      if (err.response.status === 401) {
        throw new Error('UNAUTHORIZED');
      }
      throw err;
    });
}

export async function checkOnboarding(): Promise<CheckOnboardingDto> {

    const { selectedDashboard } = (store.getState() as RootState).application;
    if (!selectedDashboard) {
        throw new Error("NO_DASHBOARD_SELECTED");
    }
    return httpService
        .get<CheckOnboardingDto>(`/marketplace/account/${selectedDashboard}`)
        .then((res) => res.data)
        .catch((err) => {
            if (err.response.status === 401) {
                throw new Error("UNAUTHORIZED");
            }
            throw err;
        });
}

export async function getLoginToDashBoardLoginLink(): Promise<StripeConnectLoginLink> {
    const { selectedDashboard } = (store.getState() as RootState).application;
    if (!selectedDashboard) {
        throw new Error("NO_DASHBOARD_SELECTED");
    }
    return httpService
        .get<StripeConnectLoginLink>(`/marketplace/account/${selectedDashboard}/login`)
        .then((res) => res.data)
        .catch((err) => {
            if (err.response.status === 401) {
                throw new Error("UNAUTHORIZED");
            }
            throw err;
        });
}

export async function checkMandateStatusForUser(userId: number): Promise<boolean> {
    const { selectedDashboard } = (store.getState() as RootState).application;
    if (!selectedDashboard) {
        throw new Error("NO_DASHBOARD_SELECTED");
    }
    return httpService
        .get<boolean>(`/marketplace/account/${selectedDashboard}/mandate/${userId}`)
        .then(() => true)
        .catch(() => false);
}

export async function getAccountBalance(): Promise<number> {
    const { selectedDashboard } = (store.getState() as RootState).application;
    if (!selectedDashboard) {
        throw new Error("NO_DASHBOARD_SELECTED");
    }
    return httpService
        .get<{balance: number}>(`/marketplace/account/${selectedDashboard}/balance`)
        .then((res) => res.data.balance)
        .catch((err) => {
            if (err.response.status === 401 || err.response.status === 403) {
                throw new Error("UNAUTHORIZED");
            }
            throw err;
        });
}